import { render, staticRenderFns } from "./TgbModal.vue?vue&type=template&id=0842b7d1"
import script from "./TgbModal.vue?vue&type=script&lang=js"
export * from "./TgbModal.vue?vue&type=script&lang=js"
import style0 from "./TgbModal.vue?vue&type=style&index=0&id=0842b7d1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports